<template>
  <div class="header">
    <header
      :style="{ 'background-color': background_color }"
      class="head-nav"
    >
      <el-row>
        <el-col
          :span="8"
          class="logo-container"
        >
          <img
            :src="logo"
            class="logo"
            alt=""
          >
        </el-col>
        <el-col :span="2">
          <div
            v-show="false"
            class="toggle-menu"
            style="left:190px"
            @click="toggleMenu"
          >
            <font-awesome-icon
              icon="bars"
              size="2x"
              title="Exibir/Ocultar Menu"
            />
          </div>
        </el-col>
        <el-col :span="8">
          <h2
            class="header, ql-align-center"
            style="letter-spacing: 5px;"
          >
            <strong>{{ titulo }}</strong>
          </h2>
        </el-col>
        <el-col :span="5">
          <el-dropdown
            v-if="exibeUsuario"
            class="menu-user"
          >
            <div class="avatar-wrapper">
              <el-avatar
                v-if="foto"
                size="large"
                :src="foto"
                fit="contain"
              />
              <font-awesome-icon
                v-else
                icon="user-circle"
                size="3x"
              />
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item disabled>
                  <font-awesome-icon icon="user" /> {{ currentUser().principal }}
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="$can('list', 'usuario')"
                  @click="onClickConfigAccout()"
                >
                  <font-awesome-icon icon="user-cog" /> Configurações da conta
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="$config && $config.isVisible('alterarsenha', false)"
                  divided
                  @click="onClickAlterPassword()"
                >
                  <font-awesome-icon icon="key" /> Alterar Senha
                </el-dropdown-item>
                <el-dropdown-item
                  divided
                  @click="onLogout()"
                >
                  <font-awesome-icon icon="sign-out-alt" /> Sair
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-col>
      </el-row>
    </header>
    <el-dialog
      v-model="visiblePassword"
      title="ALTERAR SENHA"
      :close-on-click-modal="!alertSenhaExpirada"
      :show-close="!alertSenhaExpirada"
      :close-on-press-escape="!alertSenhaExpirada"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <alert />
      <el-alert
        v-if="alertSenhaExpirada"
        title="Sua senha expirou e deve ser alterada."
        type="warning"
      />
      <el-alert
        v-if="currentUser().grupoValidaSenha"
        title="Crie uma senha com pelo menos seis caracteres (Conter letra maiúscula, minúscula, número e caractere especial)."
        type="warning"
      />
      <el-form
        :ref="formNamePassword"
        :model="usuario"
        :rules="rulesPassword"
        label-position="top"
      >
        <div class="twelve columns">
          <el-form-item
            label="Login/Usuário"
            prop="login"
          >
            <el-input
              v-model="currentUser().principal"
              auto-complete="off"
              type="text"
              readonly
            />
          </el-form-item>
        </div>
        <div class="twelve columns">
          <el-form-item
            label="Senha Atual"
            prop="senhaAtual"
          >
            <el-input
              v-model="usuario.senhaAtual"
              :maxlength="25"
              auto-complete="off"
              type="password"
            />
          </el-form-item>
        </div>
        <div class="twelve columns">
          <el-form-item
            label="Nova Senha"
            prop="senha"
          >
            <el-input
              v-model="usuario.senha"
              :maxlength="25"
              auto-complete="off"
              :show-password="$config.isVisible('login.visualizarsenha', true)"
              type="password"
            />
          </el-form-item>
        </div>
        <div class="twelve columns">
          <el-form-item
            label="Confirmar Nova Senha"
            prop="senhaConf"
          >
            <el-input
              v-model="usuario.senhaConf"
              :maxlength="25"
              auto-complete="off"
              :show-password="$config.isVisible('login.visualizarsenha', true)"
              type="password"
            />
          </el-form-item>
        </div>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button
            v-if="!alertSenhaExpirada"
            @click="onCancelDialogPassword()"
          >
            Sair
          </el-button>
          <el-button
            type="primary"
            @click="onSubmitAlterarSenha()"
          >
            Confirmar
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'pinia';
import { isUndefined } from 'lodash';
import { mainStore } from '@/store/index';
import { loginStore } from '@/app/login/vuex/index';
import Alert from '../alert/Alert.vue';

export default {
  name: 'CcHeadNav',
  components: { Alert },
  data() {
    return {
      visible: false,
      visiblePassword: false,
      alertSenhaExpirada: false,
      prestador: {
        item: {
          id: '',
        },
      },
      usuario: {
        email: '',
        senha: '',
        regras: [],
        permissoes: {},
      },
      prestadores: [],
      rules: {
        'item.id': [
          {
            required: true,
            type: 'number',
            message: 'Informe o Prestador',
            trigger: 'change',
          },
        ],
      },
      rulesPassword: {
        senhaAtual: [
          { required: true, message: 'Informe a Senha Atual', trigger: 'change' },
        ],
        senha: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value === '' || value === null || value === undefined) {
              callback(new Error('Informe a Nova Senha'));
            } else if (this.currentUser().grupoValidaSenha && (value !== undefined && value !== null && value !== '')) {
              const errors = [];
              if (!(/.{6,25}/.test(value))) errors.push('Deve ter no mínimo 6 carateres');
              if (!(/[a-z]+/.test(value))) errors.push(' Deve ter ao menos uma letra minúscula');
              if (!(/[A-Z]+/.test(value))) errors.push(' Deve ter ao menos uma letra maiúscula');
              if (!(/[0-9]+/.test(value))) errors.push(' Deve ter ao menos um número');
              if (!(/[^A-Za-z0-9]/.test(value))) errors.push(' Deve ter ao menos um caracter especial ');
              if (errors.length) callback(new Error(errors));
              callback();
            } else if (!(/^[a-zA-Z0-9_-]{5,26}$/.test(value))
            && (value !== undefined && value !== null && value !== '')) {
              callback(new Error('Nova Senha inválida'));
            } else {
              callback();
            }
          },
          trigger: 'change',
        }],
        senhaConf: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value === '' || value === null || value === undefined) {
              callback(new Error('Informe a Confirmação da Nova Senha'));
            } else if (value !== this.usuario.senha && value !== undefined) {
              callback(new Error('As senhas informadas não são iguais'));
            } else {
              callback();
            }
          },
          trigger: 'blur',
        }],
      },
    };
  },

  computed: {
    formName() { return 'ruleForm'; },

    formNamePassword() { return 'ruleFormPassword'; },
  },

  watch: {
    isLogged(value) { // isLogged changes when the token changes
      if (value === false) {
        this.$router.push({ name: 'auth' });
      }
    },
  },

  created() {

  },

  updated() {
    this.checkSenhaExpirada();
  },

  methods: {
    ...mapActions(mainStore, ['setFetching', 'loadUser']),
    ...mapGetters(loginStore, ['currentUser']),
    ...mapActions(loginStore, ['logout']),

    checkSenhaExpirada() {
      if (this.currentUser().senhaExpirada) {
        this.visiblePassword = true;
        this.alertSenhaExpirada = true;
      }
    },

    onLogout() {
      this.$confirm('Deseja sair?', 'Confirmação', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning',
      }).then(() => {
        this.logout();
        this.$router.push({ name: 'auth' });
      });
    },

    onAlterarPrestador() {
      this.visible = true;
    },

    onCancelDialog() {
      this.visible = false;
    },

    toggleMenu() {
      mainStore().state.leftMenu.menu_flag ? 'set_menu_close' : 'set_menu_open';
    },

    onClickConfigAccout() {
      this.$router.push({ name: 'usuarios', params: { menuSuperior: this.$route.name } });
    },

    onClickAlterPassword() {
      if (!isUndefined(this.$refs[this.formNamePassword])) {
        this.$refs[this.formNamePassword].clearValidate();
        this.$refs[this.formNamePassword].resetFields();
      }
      this.visiblePassword = true;
    },

    onCancelDialogPassword() {
      this.visiblePassword = false;
    },

    onSubmitAlterarSenha() {
      this.$refs[this.formNamePassword].validate((valid) => {
        if (!valid) return false;

        this.setFetching({ fetching: true });
        this.$http.put('usuarios/validar-senha', {
          login: this.currentUser().principal,
          senha: this.usuario.senhaAtual,
        }).then(() => {
          this.alterarSenha();
        });

        return true;
      });
    },

    alterarSenha() {
      this.$http.put('usuarios/alterar-senha', {
        login: this.currentUser().principal,
        senha: this.usuario.senha,
      }).then(() => {
        this.loadUser().then(() => {
          this.visiblePassword = false;
        });
        this.setFetching({ fetching: false });
      });
    },
  },

  props: {
    background_color: {
      type: String,
      required: false,
    },
    titulo: {
      type: String,
      required: false,
    },
    logo: {
      type: String,
      required: true,
    },
    foto: {
      type: String,
      required: false,
    },
    exibeUsuario: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
</script>

<style scoped lang='less'>
    .logo-container {
        height: 60px;
    }

    .logo {
        height: 50px;
        width: auto;
        margin-left: 10px;
        margin-top: 5px;
    }

    .header {
      min-width: 100%;
      width: 100%;
      position: fixed;
      z-index: 500;
      left: 0px;
      top: 0px;
    }
    .head-nav {
        margin-top: 0px;
        height: 60px;
        // background: #2d80de;
        top: 0px;
        width: 100%;
        min-width: 100%;
        color: #FFF;
    }

    .menu-user {
      float: right;
      margin-top: 6px;
      cursor: pointer;
    }

    .toggle-menu {
        width: 40px;
        height: 40px;
        position: fixed;
        top: 0px;
        /*left: 190px;*/
        z-index: 1000;
        cursor: pointer;
        line-height: 40px;
        text-align: center;
        color: #fff;
        font-size: 12px;

    }

    .avatar-wrapper {
      color:#FFF;
    }
</style>
